import {RestClient} from './RestClient';
import {Preconditions} from '../Errors/Preconditions';
import {APIError} from './APIError';

export class BaseService {
  protected apiBaseUrl: string = '';
  protected readonly restClient: RestClient;

  constructor() {
    this.restClient = new RestClient();
  }

  getApiBaseUrl(): string {
    return this.apiBaseUrl;
  }

  setApiBaseUrl(url: string) {
    Preconditions.checkNotNull(url);
    Preconditions.checkNotEmpty(url);

    this.apiBaseUrl = url;
  }

  protected throwAPIError(errorData): never {
    if (errorData.response) {
      if (errorData.response.errors) {
        throw new APIError(JSON.stringify(errorData.response.errors));
      }
      throw new APIError(JSON.stringify(errorData.response));
    }
    throw new APIError(JSON.stringify(errorData));
  }
}
